export default {
  methods: {
    showError (text, time = 2000) {
      this.$q.notify({
        message: text,
        color: 'red',
        icon: 'warning',
        timeout: time
      });
    },
    showMessage (text, time = 600) {
      this.$q.notify({
        message: text,
        color: 'secondary',
        icon: 'done',
        timeout: time
      });
    }
  }
};
